import React from 'react';

import NoResults from './noresults';
import ProgramSlider from '@search/components/programslider';

const Results = ({
  searchQuery,
  tvguideLoading,
  catchupLoading,
  tvguidePrograms,
  catchupPrograms,
  tvguideResults,
  catchupResults,
}) => (
  <div className="fv-search-app__results">
    {tvguideLoading && <div className="fv-loading" />}

    {!tvguideLoading &&
      searchQuery.length > 0 &&
      tvguideResults.length == 0 &&
      catchupResults.length == 0 && <NoResults />}

    {!tvguideLoading && searchQuery.length == 0 && tvguideResults.length == 0 && (
      <div className="fv-search-app__results__onnow">
        <ProgramSlider
          programs={tvguidePrograms}
          type="program"
          title={'Watch now'}
        />
      </div>
    )}
    {!tvguideLoading && tvguideResults.length > 0 && (
      <div className="fv-search-app__results__tvguide">
        <ProgramSlider
          programs={tvguideResults}
          type="result"
          title={'TV Guide'}
        />
      </div>
    )}

    <div className="fv-search-app__results__catchup">
      {catchupLoading && <div className="fv-loading" />}
      {!catchupLoading &&
        searchQuery.length == 0 &&
        catchupResults.length == 0 && (
          <ProgramSlider
            programs={catchupPrograms}
            type="program"
            title={'Catch up'}
          />
        )}
      {!catchupLoading && catchupResults.length > 0 && (
        <ProgramSlider
          programs={catchupResults}
          type="result"
          title={'Catch up'}
        />
      )}
    </div>
  </div>
);

export default Results;
